import { FETCH_RECIPIENT_SUCCESS } from 'constants/index';
import type { Field } from 'models';
import { combineReducers } from 'redux';

type RecipientAction = {
  type: typeof FETCH_RECIPIENT_SUCCESS;
  payload: {
    entities: {
      fields: Record<string, Field>;
    };
  };
};

export const byId = (
  state: Record<string, Field> = {},
  action: RecipientAction,
) => {
  switch (action.type) {
    case FETCH_RECIPIENT_SUCCESS:
      const {
        entities: { fields = {} },
      } = action.payload;
      return fields;
    default:
      return state;
  }
};

export const ids = (state: string[] = [], action: RecipientAction) => {
  switch (action.type) {
    case FETCH_RECIPIENT_SUCCESS:
      const {
        entities: { fields = {} },
      } = action.payload;
      return Object.keys(fields);
    default:
      return state;
  }
};

export const recipientFields = combineReducers({ byId, ids });
